import { kmsClient } from 'api';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { CAMPAIGN_QUERY, CAMPAIGN_FOR_INSIGHTS_PAGE_QUERY } from './campaign.query';
import { CampaignQuery, CampaignQueryVariables } from './__generated__/CampaignQuery';
import {
  CampaignForInsightsPageQuery,
  CampaignForInsightsPageQueryVariables
} from './__generated__/CampaignForInsightsPageQuery';

export const useCampaignOverviewQuery = (variables: CampaignQueryVariables) => {
  return useQuery<CampaignQuery, CampaignQueryVariables>(CAMPAIGN_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};

export const useCampaignOverviewLazyQuery = (variables: CampaignQueryVariables) => {
  return useLazyQuery<CampaignQuery, CampaignQueryVariables>(CAMPAIGN_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};

export const useCampaignForInsightsPageQuery = () => {
  return useLazyQuery<CampaignForInsightsPageQuery, CampaignForInsightsPageQueryVariables>(
    CAMPAIGN_FOR_INSIGHTS_PAGE_QUERY,
    {
      client: kmsClient,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true
    }
  );
};
